
export class PlanGoodsAllergenModel {
  /**
   * Ｐコード共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード仕様書２
   */
  // アレルゲン区分
  public allergenDiv: string = <string>'';

  // アレルゲン選択
  public allergenSelect: string = <string>'';
}
